import { /*CRUDBasicDetailComponent_Template, */CRUDBasicDetailComponent } from '../crud-basic-detail/crud-basic-detail.component';

import { Component, OnInit, Inject, forwardRef, Injector, ViewChild, Input } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl, FormControlName } from '@angular/forms';
import { AppComponent } from '../app.component';
import { TranslateService } from '../_services/translate.service';
import { GenericValidator } from '../_helpers/generic-validator';
/*import { AutoComplete } from 'primeng/primeng';*/
import { Params } from '@angular/router';

import { IBehaelterstandortKorrektur } from '../_interfaces/behaelterstandort-korrektur';
import { BehaelterstandortKorrekturService } from '../_services/behaelterstandort-korrektur.service';
import { BehaelterstandortKorrekturDetailGuard } from './behaelterstandort-korrektur-detail.guard';

import { IAuftragsdaten } from '../_interfaces/auftragsdaten';
import { AuftragsdatenService } from '../_services/auftragsdaten.service';

declare var jquery: any;
declare var $: any;

//import { BehaelterstandortKorrekturDetailComponent_Template } from './behaelterstandort-korrektur-detail.component.include_template';

@Component({
  selector: 'app-stammdatenKorrektur-detail',
  //template: `${CRUDBasicDetailComponent_Template || ''}${BehaelterstandortKorrekturDetailComponent_Template}`,
  templateUrl: './behaelterstandort-korrektur-detail.component.html',
  styleUrls: ['../crud-basic-detail/crud-basic-detail.component.css'],
  host: { '(window:keydown)': 'hotkeys($event)' }
})
export class BehaelterstandortKorrekturDetailComponent extends CRUDBasicDetailComponent implements OnInit {
  // CHILD-spezifisch: Konstanten - START
  CRUDItemKurzform: string = "BehaelterstandortKorrektur";
  CRUDPageTitleNeu: string = this.translate.instant("Änderung Behälterstandort", true);
  CRUDPageTitleBearbeiten: string = this.translate.instant("Änderung Behälterstandort", true);
  CRUDItemBezeichnungSingularCapitalized: string = "BehaelterstandortKorrektur";
  CRUDItemBezeichnungPluralCapitalized: string = "BehaelterstandortKorrekturen";
  CRUDItemBezeichnungSingular: string = "behaelterstandortKorrektur";
  CRUDItemBezeichnungPlural: string = "behaelterstandortKorrekturen";
  CRUDItemRouteSingular: string = "behaelterstandort-korrektur";
  CRUDItemRoutePlural: string = "behaelterstandort-korrekturen";
  CRUDItemHelpTopic: string = null;
  // CHILD-spezifisch: Konstanten - Ende

  // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - START

  // queryParams
  queryParams: Params = null;

  offlineMode: boolean = false;

  // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - ENDE

  constructor(
    @Inject( forwardRef(() => AppComponent)) public _app: AppComponent,
    private _injector: Injector,
    private _translate: TranslateService,
    private _crudItemService: BehaelterstandortKorrekturService,
    private _guard: BehaelterstandortKorrekturDetailGuard,
    private auftragsdatenService: AuftragsdatenService,

    // CHILD-spezifisch: zusätzliche Services - START
    // CHILD-spezifisch: zusätzliche Services - ENDE
  ) {
    super(_app, _injector);

    this.crudItemService = _crudItemService;
    this.guard = _guard;

    // CHILD-spezifisch die Validator Messages bestücken - START
    this.validationMessages =
    {
      status: {
        required: this._translate.instant('Status', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Status', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      kundennummer: {
        required: this._translate.instant('Kundennummer', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Kundennummer', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      behaelternummer: {
        required: this._translate.instant('Behälternummer', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Behälternummer', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      name_1: {
        required: this._translate.instant('Name 1', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Name 1', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      name_2: {
        maxlength: this._translate.instant('Name 2', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      strasse: {
        maxlength: this._translate.instant('Strasse', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      plz: {
        //required: this._translate.instant('PLZ', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('PLZ', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      ort: {
        //required: this._translate.instant('Ort', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Ort', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      ortzusatz: {
        maxlength: this._translate.instant('Ortzusatz', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      telefon: {
        maxlength: this._translate.instant('Telefon', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      telefonGeschaeftlich: {
        maxlength: this._translate.instant('Telefon Geschäftlich', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      telefonPrivat: {
        maxlength: this._translate.instant('Telefon Privat', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      telefonMobil: {
        maxlength: this._translate.instant('Telefon Mobil', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      eMail: {
        maxlength: this._translate.instant('E-Mail', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      bemerkung: {
        maxlength: this._translate.instant('Bemerkung', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },
};
    // CHILD-spezifisch die Validator Messages bestücken - ENDE
    
    this.genericValidator = new GenericValidator(this.validationMessages);

    this.buildForm();
  }

  buildForm() {
    // CHILD-spezifisch die Form aufbauen - START
    this.CRUDForm = this.fb.group({
      //status: [''/*, [Validators.required, Validators.maxLength(255)]*/],
      //kundennummer: ['', [Validators.required, Validators.maxLength(255)]],
      //behaelternummer: ['', [Validators.required, Validators.maxLength(255)]],
      name_1: ['', [Validators.required, Validators.maxLength(255)]],
      name_2: ['', [Validators.maxLength(255)]],
      strasse: ['', [Validators.maxLength(255)]],
      plz: ['', [/*Validators.required, */Validators.maxLength(255)]],
      ort: ['', [/*Validators.required, */Validators.maxLength(255)]],
      ortzusatz: ['', [Validators.maxLength(255)]],
      telefon: ['', [Validators.maxLength(255)]],
      telefonGeschaeftlich: ['', [Validators.maxLength(255)]],
      telefonPrivat: ['', [Validators.maxLength(255)]],
      telefonMobil: ['', [Validators.maxLength(255)]],
      geodaten_Breite: [null],
      geodaten_Laenge: [null],
      eMail: ['', [Validators.maxLength(50)]],
      bemerkung: ['', [Validators.maxLength(255)]],
    });
    // CHILD-spezifisch die Form aufbauen - ENDE
  }

  ngOnInit() {
    this.blockedDocument = true;

    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - START

    this.route.queryParams.subscribe(params => {
      console.log("BehaelterstandortKorrekturDetailComponent.ngOnInit() params/this:", params, this);
      this.queryParams = params;
    });

    // OFFLINE-MODE ? id und andere query parameters per JS holen (kein ng Router!)
    //let searchParams = new URLSearchParams(window.location.search); // https://sentry.io/answers/how-to-get-values-from-urls-in-javascript/
    let searchParams = this._app.initialURLSearchParams; // https://sentry.io/answers/how-to-get-values-from-urls-in-javascript/
    // im Prinzip erkennt er den offline-mode eh schon aufgrund AppConfigService, man kann aber alternativ (zum Test) auch ?offline=T mitgeben
    if((searchParams.has('offline') && searchParams.get('offline') == 'T') || this.config.get('dataMode').localeCompare/*("online") != 0*/("maui") == 0) {
      this.offlineMode = true;
      //for (let param of searchParams) {
      //  console.log(param);
      //}
      this.dataId = parseInt(searchParams.get("id"));
      this.queryParams = {
        auftragsId: parseInt(searchParams.get("auftragsId")),
        kundenNr: searchParams.get("kundenNr"),
        behaelterNr: searchParams.get("behaelterNr"),
        nav: searchParams.get("nav")
      }
      console.log("BehaelterstandortKorrekturDetailComponent.ngOnInit() OFFLINE: getting dataId/queryParams:", this.dataId, this.queryParams);
    }
    
    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - ENDE

    super.ngOnInit();
  }

  getValuesFromForm() {
    let a = super.getValuesFromForm(); // Standard! do not change!

    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - START
    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - ENDE

    //console.log("BehaelterstandortKorrekturDetailComponent.getValuesFromForm() a:", a);
    return a;
  }

  sendValuesToForm() {
    // CHILD-spezifisch die Form patchen - START
    this.CRUDForm.patchValue({
      //status: this.CRUDItem.status,
      //kundennummer: this.CRUDItem.kundennummer,
      //behaelternummer: this.CRUDItem.behaelternummer,
      name_1: this.CRUDItem.name_1,
      name_2: this.CRUDItem.name_2,
      strasse: this.CRUDItem.strasse,
      plz: this.CRUDItem.plz,
      ort: this.CRUDItem.ort,
      ortzusatz: this.CRUDItem.ortzusatz,
      telefon: this.CRUDItem.telefon,
      telefonGeschaeftlich: this.CRUDItem.telefonGeschaeftlich,
      telefonPrivat: this.CRUDItem.telefonPrivat,
      telefonMobil: this.CRUDItem.telefonMobil,
      geodaten_Breite: this.CRUDItem.geodaten_Breite,
      geodaten_Laenge: this.CRUDItem.geodaten_Laenge,
      eMail: this.CRUDItem.eMail,
      bemerkung: this.CRUDItem.bemerkung
});
    // CHILD-spezifisch die Form patchen - ENDE
    //console.log("BehaelterstandortKorrekturDetailComponent.sendValuesToForm() CRUDForm:", this.CRUDForm);
    super.sendValuesToForm(); // haben nicht alle DetailComponents - erst ab Ticket 9412 17.07.2019
  }

  getCRUDBezeichnung() { // Overwrite!
    //if(this.CRUDForm != null && this.CRUDForm.get('bezeichnung') != null) return this.CRUDForm.get('bezeichnung').value;
    return this.CRUDItem.name_1;
  }

  onCRUDItemRetrieved(CRUDItem: /*IAnrede*/any): void { // overwrite
    console.log("BehaelterstandortKorrekturDetailComponent.onCRUDItemRetrieved() CRUDItem:", CRUDItem);

    if(this.dataId == 0) { // Neuanlage
      //if(this.queryParams != null) {
        CRUDItem.kundennummer = this.queryParams.kundenNr;
        CRUDItem.behaelternummer = this.queryParams.behaelterNr;
      //}

      this.auftragsdatenService.getAuftragsdaten(this.queryParams.auftragsId).subscribe((response) => {
        console.log("BehaelterstandortKorrekturDetailComponent.onCRUDItemRetrieved() getAuftragsdaten() response:", response);

        //CRUDItem.bemerkung = response.bemerkung;
        CRUDItem.name_1 = response.name_1Behaelterstandort;
        CRUDItem.name_2 = response.name_2Behaelterstandort;
        CRUDItem.ort = response.ortBehaelterstandort;
        CRUDItem.ortzusatz = response.ortzusatzBehaelterstandort;
        CRUDItem.plz = response.plzBehaelterstandort;
        CRUDItem.strasse = response.strasseBehaelterstandort;
        CRUDItem.telefon = response.telefonBehaelterstandort;
        CRUDItem.telefonGeschaeftlich = response.telefonGeschaeftlichBehaelterstandort;
        CRUDItem.telefonPrivat = response.telefonPrivatBehaelterstandort;
        CRUDItem.telefonMobil = response.telefonMobilBehaelterstandort;
        CRUDItem.eMail = response.eMailBehaelterstandort;
        CRUDItem.geodaten_Breite = response.geodaten_Breite;
        CRUDItem.geodaten_Laenge = response.geodaten_Laenge;

        //this.blockedDocument = false;
        super.onCRUDItemRetrieved(CRUDItem);
        this._app.iOSFixResizeWebview('BehaelterstandortKorrekturDetail.onCRUDItemRetrieved');
      }, function (error) { 
        console.error("BehaelterstandortKorrekturDetailComponent.onCRUDItemRetrieved() getAuftragsdaten() error:", error);
        return this.handleError(error); 
      });
    }
    else {
      super.onCRUDItemRetrieved(CRUDItem);
      this._app.iOSFixResizeWebview('BehaelterstandortKorrekturDetail.onCRUDItemRetrieved');
    }

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this._app.iOSFixResizeWebview('BehaelterstandortKorrekturDetail.ngAfterViewInit');
  }

  //afterSaveCRUDItem() { 
  //  setTimeout(() => {
  //    this.messageWrapperService.postStaticMessage({ severity: 'info', summary: "Stammdatenänderung", detail: "Vielen Dank!<br><br>Die Stammdatenänderung wurde an Primagas übermittelt.<br><br>Achtung:<br>Die Änderung ist erst sichtbar, wenn Primagas die Daten überprüft hat." }); 
  //  }, 1000);
  //}

  navigateToMapOrList() {
    //In der App (Offline) discard Event auslösen damit View sich wider schließt
    if (this.config.get('dataMode').localeCompare("maui") == 0) { 
      setTimeout(() => {
        let eventData = {
          eventType: "discard",
          data: JSON.stringify(
          {
            discard: "discard"
          })
        };
        this.app.sendMessageToDotNet(eventData);
      }, 10);		
    }
    else {
      let navigateTo = "/map"; // default

      if(this.queryParams != null) {
        if(this.queryParams.nav == 'map') navigateTo = "/map"; // wenn queryParam vorhanden, dann entspr. nach map Oder Liste navigieren
        else if(this.queryParams.nav == 'list') navigateTo = "/list"; // wenn queryParam vorhanden, dann entspr. nach map Oder Liste navigieren
      }
  
      this.router.navigate([navigateTo]);
    }
  }

  cancelCRUDEdit() { // overwrite
    //this.router.navigate(['/map']);
    this.navigateToMapOrList();
  }

  onSaveComplete(close: boolean): void { // overwrite - aber nur wegen dem navigate - und der abweichenden Meldung
    this.blockedDocument = false;
    let bezeichnung = this.getCRUDBezeichnung();

    //MODI:
    //this.messageWrapperService.postTimedMessage({ severity: 'success', summary: this.deleted ? this.translate.instant("Löschen erfolgreich", true) : this.translate.instant("Speichern erfolgreich", true), detail: bezeichnung }) // TO DO
    this.messageWrapperService.postStaticMessage({ severity: 'info', summary: "Änderung Behälterstandort", detail: "Vielen Dank!<br><br>Die Änderung des Behälterstandorts wurde an das Backoffice übermittelt.<br><br>Achtung:<br>Die Änderung ist erst sichtbar, wenn die Daten im Backoffice überprüft wurden." }); 

    this.CRUDForm.reset();
    // US 14152: Es gibt ein Problem, wenn man ein Feld ändert, NICHT verlässt, per STRG+S zwischenspeichert.
    // in dem Fall bleibt das Feld / die Form dirty. Der dirty muss aber raus, sonst kann man die Form nicht verlassen (guard!)
    if(close == false) {
      let activeElement = $(document.activeElement);
      if(activeElement != null) {
        activeElement.blur();
        activeElement.focus();
      }
    }
    if (close) {
      //console.log("CRUDBasicDetailComponent.onSaveComplete() routing to:", this.CRUDItemRoutePlural);
      //this.router.navigate(['/' + this.CRUDItemRoutePlural], { queryParamsHandling: "merge" });

      // wenn Abschliessen -> zur Map
      //this.router.navigate(['/map']);
      this.navigateToMapOrList();
     
    }
  }

  getGeoDaten(event: any) {
    event.preventDefault(); // verhindert das Springen nach oben
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        this.CRUDForm.patchValue({
          geodaten_Breite: lat,
          geodaten_Laenge: lon});
        console.log('BehaelterstandortKorrektur.getGeoDaten() '+`Breitengrad: ${lat}, Längengrad: ${lon}`);
      },
      (error) => {
        console.error('BehaelterstandortKorrektur.getGeoDaten() '+"Fehler beim Abrufen der Position:", error.message);
      }
    );
    } else {
      console.error('BehaelterstandortKorrektur.getGeoDaten() '+"Geolocation wird von diesem Browser nicht unterstützt.");
    }
  }

  ngOnDestroy(): void {
    console.log("BehaelterstandortKorrekturDetailComponent.ngOnDestroy()");

    if(this._app.getMapComponent() != null) {
      this._app.iOSFixResizeWebview('BehaelterstandortKorrekturDetail.ngOnDestroy');
    }
  } 


}
